/* eslint-disable eqeqeq, func-names, max-len, no-new, no-plusplus, no-shadow, no-underscore-dangle */
if ($('#win-terms-text') !== 0) {
  $(document).ready(() => {
    SortTermsSpacing();
    animateTerms();
    GetHeight();
    $(window).resize(() => {
      GetHeight();
    });

    // reload on partial postback
    const prm = Sys.WebForms.PageRequestManager.getInstance();
    if (prm !== null) {
      prm.add_endRequest((sender) => {
        if (sender._postBackSettings.panelsToUpdate !== null) {
          SortTermsSpacing();
          animateTerms();
          GetHeight();
          $(window).resize(() => {
            GetHeight();
          });
        }
      });
    }

    function SortTermsSpacing() {
      const $termsText = $('#win-terms-text .container p');

      if ($termsText.length !== 0) {
        $termsText.html($termsText.html().replace(/\n/g, '<br />'));
      }
    }

    // Get required page height
    function GetHeight() {
      $('#win-terms-text.open-terms').css('height', '100%');
      // var height = 0;
      // var termsHeight = $(".terms-btn-text").offset().top + 50;
      // var selectHeight = 0;

      // if (termsHeight > selectHeight) {
      //    height = termsHeight;
      // } else {
      //    height = selectHeight;
      // }

      // if (height > $(window).outerHeight()) {
      //    $("#win-terms-text").attr("data-height", height);
      // } else {
      //    $("#win-terms-text").attr("data-height", "100%");
      // }
      $('#win-terms-text').attr('data-height', '100%');
    }

    function animateTerms() {
      // Terms animation
      $('.terms-btn-text, .js-terms-btn').click((event) => {
        if ($(event.currentTarget).is('span')) {
          return;
        }

        event.preventDefault();

        const $termsText = $('#win-terms-text');

        if (!$termsText.hasClass('open-terms')) {
          $termsText.addClass('open-terms');
          $termsText.height($termsText.attr('data-height'));
        } else {
          $termsText.removeClass('open-terms');
        }
      });

      // Close on X
      $('#win-terms-text .close-terms').click(() => {
        const $termsText = $('#win-terms-text');

        if (!$termsText.hasClass('open-terms')) {
          $termsText.addClass('open-terms');
        } else {
          $termsText.removeClass('open-terms');
          $termsText.height(0);
        }
      });

      // Close terms on esc
      $(document).keyup((e) => {
        if (e.keyCode == 27) {
          const $termsText = $('#win-terms-text');

          if ($termsText.hasClass('open-terms')) {
            $termsText.removeClass('open-terms');
            $termsText.height(0);
          }
        }
      });
    }
  });
}
